module.exports = __webpack_public_path__ + "img/chevron_white_left_32px.f0f15a93.png";